export default "__VITE_ASSET__CYuQQ0Ux__"